

function Now() { 
    return(
        <div className='Now text-page'>
            <h2>
            What am I doing Now? like <a href="https://www.nownownow.com/about">Now Now Now</a>? Now as of 7/29/2026?
            </h2>
             <h3>
                I am Farming Full Time:
            </h3>
            <h4>
                    I am working on <a href="https://www.bountifulblessingsfarm.com">Bountiful Blessings Farm</a> in Williamsport TN, It is a 7 Acre Market Garden and it is really been an awesome experience. I love the variety of things to do and the slower pace. The fact that I am making a real impact in individual lives by providing good clean food. The Spirtual fufillment here is so the best! Just all around I am happy that I left working out in a factory and went to working out in nature.
            </h4>

            <h3>
                I am Dating Brianna Beckner:
            </h3>
            <h4>
                    Brianna and I have been dating for almost a year now and it has been an amazing experience. She is super sweet and caring and we have a lot of fun together. We love going on hikes, farming, and just spending time together. I feel really lucky to have found someone like her. and the fact that she is a farmer with a love for God too is all I can really ask for.
            </h4>
            <h3>
                I am Growing in my Faith:
            </h3>
            <h4>
                    I have been focusing on my relationship with God. I have been reading my Bible more and praying more. I have been going to church more regularly. I feel like I am starting to understand what it means to be a Christian and I am excited to see where this journey takes me. 
            </h4>
            <h3>
                I am Riding a Bike to Work:
            </h3>
            <h4>
                    I bough a Trek Marlin 4 Gen 3 from the Trek store and I am honestly happy with it but I wish I supported a local bike shop more but hey. this is the first time that I have ever owned a bike with gears. I have enjoyed it so far. I have added accessories to it, like a headlight, a red blinky light, a kick stand and a rack on the back wheel. I still have not figured out how to full use that part of the bike but it is something that I should figure out soon. it has been freeing not using fossil fuels to go to work. I love being more connected with the land and I use it on the farm to get around aswell. I understand that I enjoy it so much because I do not to commute that far but it is nice to save money and lose stomach fat at the same time. Another plus is I just started recycling and it feels epic biking my recycling. 
            </h4>
            <h3>
                I am Playing Hacky Sack:
            </h3>
            <h4>
                    to fully round out my hippy persona I have picked up kicking the sack around. It is so much fun to be in a circle of people that have never done it before, whip a small bag of sand out of my pocket and instantly be transported to laughs and serious concentration. I/we am/are not that good yet but it is a lot of fun trying.
            </h4>
            <h3>
                I am on the AdAgrA Programming Committee:
            </h3>
            <h4>
                    This isn't so new but I have been on the comittee that plans what is happening at the <a href="https://adventistag.org/">Adventist Agriculture National Conference</a>. It is good way to spend a week in Januarary, and it is were I met everyone on the farm I am working at (and Brianna :)). If you have anything that you would like to add to conference then let me know!
            </h4>
        </div>
    )
}

export default Now